import { render, staticRenderFns } from "./PayInfoHeader.vue?vue&type=template&id=285261fe"
import script from "./PayInfoHeader.vue?vue&type=script&lang=js"
export * from "./PayInfoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports